export const getSimpleDateRangePickerStyle = () => ({
  simpleDateRangePicker: {
    '& .compared-date-range-picker-dialog': {
      position: 'relative',
      top: 'auto!important',
      right: 'auto!important',
      left: 'auto!important',
      width: 'auto!important',
      height: 'auto!important',
      padding: 16,
    },
  },
});
